var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 39,
    viewBox: "0 0 29 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1243 0C6.33613 0 0 6.33614 0 14.1243C0 23.7896 12.6399 37.9788 13.1781 38.5781C13.6835 39.1411 14.5661 39.1401 15.0706 38.5781C15.6088 37.9788 28.2487 23.7896 28.2487 14.1243C28.2485 6.33614 21.9125 0 14.1243 0ZM14.1243 21.2306C10.2059 21.2306 7.0181 18.0427 7.0181 14.1243C7.0181 10.2058 10.206 7.01803 14.1243 7.01803C18.0427 7.01803 21.2305 10.2059 21.2305 14.1243C21.2305 18.0428 18.0427 21.2306 14.1243 21.2306Z",
    fill: "#7CB93C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.d47ab753a1d595e6bab19547334e5a0e.svg";
export { ForwardRef as ReactComponent };